// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const PurchaseOrderAggregatedSourceSourceTypeValues = [
	"CUSTOMER_ORDER_LINE",
	"ACTIVITY_MATERIAL_LINE",
	"SHOP_ORDER_LINE",
] as const;

export type PurchaseOrderAggregatedSourceSourceType = (typeof PurchaseOrderAggregatedSourceSourceTypeValues)[number];

export const getPurchaseOrderAggregatedSourceSourceTypeLabels = () => ({
	CUSTOMER_ORDER_LINE: t("customer_order_line"),
	ACTIVITY_MATERIAL_LINE: t("activity_material_line"),
	SHOP_ORDER_LINE: t("shop_order_line"),
});

export const getPurchaseOrderAggregatedSourceSourceTypeLabel = (
	value: PurchaseOrderAggregatedSourceSourceType,
): string => {
	return getPurchaseOrderAggregatedSourceSourceTypeLabels()[value];
};
